import React from "react";

type TypeProps = {
  color: string;
};

const Icon = ({ color }: TypeProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15.849"
      height="2"
      viewBox="0 0 15.849 1"
    >
      <g transform="translate(-2713.103 -1096.525)">
        <line
          x2="15.849"
          transform="translate(2713.103 1097.025)"
          fill="none"
          stroke={color}
          strokeMiterlimit="10"
          strokeWidth="2"
        />
      </g>
    </svg>
  );
};

export default Icon;
